/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import '@proto/teamdev/licensing/q/product/product_view_pb';

/**
 * A projection state of the certain product.
 *
 * The view includes single product item.
 */
//TODO:05.12.2022:yehor.pytomets:ls-spine-model: Rework this type.
type ProductView = proto.teamdev.licensing.q.product.ProductView;
export default ProductView;
export const ProductViewProto = proto.teamdev.licensing.q.product.ProductView;

/**
 * An entity which represents a version of the product.
 */
export type VersionItem = proto.teamdev.licensing.q.product.VersionItem;
export const VersionItemProto = proto.teamdev.licensing.q.product.VersionItem;

export type ProductDropDownList = proto.teamdev.licensing.q.product.ProductDropDownList;
export const ProductDropDownListProto = proto.teamdev.licensing.q.product.ProductDropDownList;

export type ProductDropDownListItem = proto.teamdev.licensing.q.product.ProductDropDownList.ProductDropDownListItem;
export const ProductDropDownListItemProto = ProductDropDownListProto.ProductDropDownListItem;
